import { render, staticRenderFns } from "./UiButtonAdd.vue?vue&type=template&id=1bfc707a&scoped=true&"
import script from "./UiButtonAdd.vue?vue&type=script&lang=js&"
export * from "./UiButtonAdd.vue?vue&type=script&lang=js&"
import style0 from "./UiButtonAdd.vue?vue&type=style&index=0&id=1bfc707a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc707a",
  null
  
)

export default component.exports